/* eslint-disable import/no-anonymous-default-export */
export default {
  SET_MESSAGE: 'SET_MESSAGE',
  
  CLEAR_MESSAGES: 'CLEAR_MESSAGES',
};
